import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import SignupFormComponent from '@fuww/library/src/Users/SignupForm';
import { useMutation } from '@apollo/client';
import { useIntl } from 'react-intl';
import { CaptchaWithController } from '../Captcha';
import ServerValidation from '../ServerValidation';
import registerMutation from '../../lib/mutations/register.graphql';
import messages from '../../lib/messages.mjs';
import { handleUserRegistration } from './Signup';
import getEmailSuggestionFormatter from '../../lib/getEmailSuggestionFormatter';

const SignupForm = ({ setSignupSuccess }) => {
  const intl = useIntl();

  const [submitErrors, setSubmitErrors] = useState(null);
  const [submitDisabled, setSubmitDisabled] = useState(false);

  const [
    registerUser,
  ] = useMutation(registerMutation, {
    onCompleted: () => {
      setSubmitDisabled(false);
      setSignupSuccess(true);
    },
    onError: (error) => {
      setSubmitErrors(error);
      setSubmitDisabled(false);
    },
  });

  const captchaReference = useRef(null);

  const submitHandler = ({
    firstName, lastName, email, password, captchaResponse,
  }) => {
    setSubmitDisabled(true);
    setSubmitErrors(null);
    handleUserRegistration(captchaReference, registerUser, {
      firstName,
      lastName,
      email,
      password,
      captchaResponse,
    });
  };

  return (
    <SignupFormComponent
      firstNameLabel={intl.formatMessage(messages.firstName)}
      lastNameLabel={intl.formatMessage(messages.lastName)}
      emailAddressLabel={intl.formatMessage(messages.emailAddress)}
      passwordLabel={intl.formatMessage(messages.password)}
      requiredValidationMessage={intl.formatMessage(messages[
        'applicantForm.fieldRequired'
      ])}
      emailValidationMessage={intl.formatMessage(messages[
        'applicantForm.mustBeValidEmailAddress'
      ])}
      passwordTooShortMessage={intl.formatMessage(messages[
        'register.passwordTooShort'
      ])}
      submitLabel={intl.formatMessage(messages.register)}
      formatEmailSuggestion={getEmailSuggestionFormatter(intl)}
      CaptchaElement={CaptchaWithController}
      captchaReference={captchaReference}
      submitHandler={submitHandler}
      submitDisabled={submitDisabled}
      serverValidation={submitErrors && (
        <ServerValidation errors={submitErrors} />
      )}
    />
  );
};

SignupForm.propTypes = {
  setSignupSuccess: PropTypes.func.isRequired,
};

export default SignupForm;
